module.exports = __webpack_public_path__ + "img/t14.2b983438.jpeg";